import LinkedAppointmentLicenses from './LinkedAppointmentLicenses';
export default LinkedAppointmentLicenses;
